<template>
  <div class="page-content homeworkPage">
    <!-- <div class="pageTitleBox d-flex d-flex-middle d-flex-between">
      <p class="pageTitle">试卷订单</p>
    </div> -->
    <p class="newMine_pageTitle newMine_pageTitleb m-b10">
        <span class="newMine_pageTitles">试卷订单</span>
      </p>
    <div class="content">
      <div v-if="list.length == 0" style="text-align: center;">暂无订单</div>
      <!-- <div class="li">
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">订单号：</p>
            <p class="color3">B60C7EED47B84970B3482D18B1A77542</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">学年：</p>
            <p class="color3">第1学年</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">金额：</p>
            <p class="color3" style="color: red; font-weight: bold;">998.00</p>
          </div>
        </div>
        <div class="btns">
          <el-button size="mini" class="my-btn" type="primary" @click="handlePay()">支付</el-button>
        </div>
      </div> -->
      <div class="li" v-for="(item,index) in list" :key="index">
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div v-if="item.orderNo" class="descLi d-flex d-flex-middle">
            <p class="color9">订单号：</p>
            <p class="color3">{{ item.orderNo }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">课程：</p>
            <p class="color3">{{ item.product }}</p>
          </div>
        </div>
        <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">金额：</p>
            <p class="color3" style="color: red; font-weight: bold;">{{ item.amount }}</p>
          </div>
        </div>
        <div v-if="item.refundStatus" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核状态：</p>
            <p class="color3">{{ item.refundStatus == 1 ? '退费成功' : '退费失败' }}</p>
          </div>
        </div>
        <div v-if="item.opinion" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核意见：</p>
            <p class="color3">{{ item.opinion }}</p>
          </div>
        </div>
        <div v-if="item.filePath" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
          <div class="descLi d-flex d-flex-middle">
            <p class="color9">审核附件：</p>
            <p class="color3"><img :src="item.filePath" style="width: 80px; height: 80px;" alt=""></p>
          </div>
        </div>
        <div class="btns">
          <el-button size="mini" v-if="item.status == 'WZF'" class="my-btn" type="primary" @click="handlePay(item.id ,item.yearTime)">支付</el-button>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="form.size"
        :total="total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>

    <el-dialog title="申请退费" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="申请原因" prop="remark">
          <el-input v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="resetForm('ruleForm')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogVisible" title="扫码缴费" @close="cancelTimer">
      <div>
        <div>
          <table class="table table-bordered">
            <tbody>
            <tr>
              <th>订单编号：</th>
              <td colspan="2"><strong>{{ orderDetail.orderNo }}</strong></td>
            </tr>
            <tr>
              <th>订单金额：</th>
              <td colspan="2" style="color:red;">￥{{ orderDetail.amount }}元</td>
            </tr>
            <tr>
              <th>课程：</th>
              <td colspan="2">{{ orderDetail.product }}</td>
            </tr>
            <tr>
              <th>创建时间：</th>
              <td>{{ orderDetail.createTime }}</td>
            </tr>
            </tbody>
          </table>
          <!-- 显示支付操作 -->
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-success" role="alert">
                <div style="font-size:16px"><strong>请选择以下2种支付方式进行扫码支付，在提示您支付成功之前，请勿关闭当前窗口</strong></div>
                <div style="font-size:16px"><strong><em>（注意：请勿重复支付）</em></strong></div>
              </div>
            </div>
            <div class="col-xs-6 pay-method-box">
              <a href="javascript:void(0)" @click="wxpay" class="pay-method">
                <img :src="wxQrcode || 'https://jxjy-att.whxunw.com/sczk_att/upload/20250616/7d134a8cc2224b04a076b7efc822b9bb.png'" alt="微信支付" :style="wxStyle">
              </a>
            </div>
            <div class="col-xs-6 pay-method-box">
              <a href="javascript:void(0)" class="pay-method" @click="alipay">
                <img src="../assets/alipay.png" alt="支付宝支付" style="height: 60px; width: 100%; display: block;margin-top:80px">
              </a>
            </div>
          </div>
        </div>
        <!-- 隐藏支付宝跳转表单 -->
        <div style="display:none" id="ali_submit_div">

        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="cancelTimer" size="mini" type="primary">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      list: [],
      form:{
        size: 10,
        current: 1,
      },
      total:0,
      orders: [],
      dialogFormVisible: false,
    rules: {
      remark: [
        { required: true, message: '请输入申请原因', trigger: 'blur' },
      ],
    },
    dialogVisible: false,
    orderDetail: {},
    wxQrcode: '',
    wxStyle: {
      height: '60px',
      width: '100%',
      display: 'block',
      marginTop: '80px'
    },
    timer: null
  };
},
  async mounted() {
    this.wxQrcode = ''
    this.getData()
  },
  methods: {
    handleDownload(url) {
      window.open(url)
    },
    handleBack(id) {
      this.dialogFormVisible = true
      this.form.id = id
    },
    handleCancel(id) {
      let _this = this
      this.$confirm('确定撤回申请吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get('/student/pc/order/refund/remove/' + id).then((res) => {
          this.$message({
            type: 'success',
            message: '撤回成功!'
          });
          _this.getData()
        })
      })
    },
    async getData() {
      this.$http.get('/student/pc/order/chooseCourse/orders',this.form).then((res) => {
        this.list = res.records
        this.total = res.total
      })
    },
    changePage(e){
      this.form.current = e
      this.getData();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.get('/student/pc/order/refund/apply',this.form).then((res) => {
            this.getData()
            this.$message({
              type: 'success',
              message: '申请成功!'
            });
            this.resetForm('ruleForm')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false
    },
    detail(row){
      this.$router.push('/paperDetail?type=HOMEWORK&id='+row.paperId+'&examDataId='+row.examDataId+'&myScore='+row.score+'&examConfigId='+this.form.examConfigId)
    },
    handlePay(orderId, feeType) {
      if (orderId) {
        this.$http.get('/student/pc/order/detail/' + orderId).then(res => {
          this.orderDetail = res
          this.dialogVisible = true
        })
      } else {
        this.$http.post('/student/pc/studyFee/order/create/' + feeType).then(res => {
          this.orderDetail = res
          this.dialogVisible = true
        })
      }
      // ALI
    },
    wxpay() {//发起微信支付
      if (this.wxQrcode) {
        return;
      }
      if (!this.timer) {
        this.createTimer();
      }
      this.$http.get('/student/pc/getPayInfo', { orderId: this.orderDetail.id, }).then(res => {
        console.log(res);
        this.wxQrcode = res
        this.wxStyle = {
          height: '100%',
          width: '100%',
          display: 'block'
        };
      })
    },
    createTimer() {
      this.timer = setInterval(() => {
        const params = {
          orderId: this.orderDetail.id
        }
        this.$http.get(`/student/pc/isPayed`, params).then((res) => {
          if (res) {
            this.cancelTimer()
          }
        });
      }, 3000);
    },
    cancelTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.dialogVisible = false
      this.getData();
    },
    async alipay() {//发起支付宝支付
      if (!this.timer) {
        this.createTimer();
      }

      this.$http.get('/student/pc/getPayInfo', { orderId: this.orderDetail.id, payMethod: 'ALIPAY' }).then(res => {
        let aliSubmitDiv = document.getElementById('ali_submit_div');
        aliSubmitDiv.innerHTML = res;
        let formId = 'alipcpayform_' + this.orderDetail.orderNo;
        let formedom = document.getElementById(formId);
        formedom.submit();
      })
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.btns {
		display: flex;
		justify-content: flex-end;
		font-size: 13px;

		.my-btn {
			// background: linear-gradient(-90deg, #7275f6, #6eadf8);
			// padding: 6px 10px;
			// border: 6px;
			// color: #fff;
			// border-radius: 6px;
			margin-left: 10px;
		}
	}
.txtOver {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.homeworkPage{
  .pageTitleBox{
    height: 80px;
    box-sizing: border-box;
    padding: 0 30px;
    .pageTitle{
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
    .mb0{
      margin-bottom: 0;
    }
  }
  .tabs {
    width: 100%;
    height: 40px;
    background: $primary;
    p {
      width: 80px;
      text-align: center;
      margin: 0 30px;
      font-size: 16px;
      cursor: pointer;
      line-height: 40px;
      position: relative;
      color: rgb(51, 51, 51);
    }

    i {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 4px;
      background-color: transparent;
      background: transparent;
    }

    .on {
      color: $primary;
    }

    .bgColor {
      background: $primary;
    }
  }
  .content{
    box-sizing: border-box;
    padding: 0 50px;
    min-height: 450px;
    .li{
      width: 100%;
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      padding: 20px 0;
      .topLi{
        margin-bottom: 10px;
        .icon{
          width: 18px;
          height: 18px;
          margin-right: 5px;
          position: relative;
          top: 2px;
        }
        .name{
          font-size: 16px;
          color: #333;
        }
        .score{
          height: 20px;
          line-height: 20px;
          background: #FFA800;
          color: #fff;
          border-radius: 10px;
          margin-left: 10px;
          text-align: center;
          box-sizing: border-box;
          padding: 0 5px;
          font-size: 13px;
        }
        .btns{
          font-size: 16px;
          p{
            margin-left: 20px;
          }
        }
      }
      .descBox{
        font-size: 14px;
        .descLi{
          margin-right: 50px;
        }
      }
    }
  }
  
  .pagination{
    display: flex;
    justify-content: center;
    align-content: center;
  }
}

.pay-method-box {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-method {
  height: 220px;
  width: 220px;
  display: block;
  border: 1px solid #ccc;
  padding: 0 12px;
  cursor: pointer;
}
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

</style>
